// App-shell skeletons for the Cook app — shown during auth init + lazy chunk
// download so the cook never sees a bare spinner (mirrors each screen's layout).

function OrderCardSkeleton() {
    return (
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm flex overflow-hidden">
            <div className="w-1.5 self-stretch bg-gray-100" />
            <div className="py-4 pl-4 pr-5 border-r border-dashed border-gray-200 min-w-[112px]">
                <div className="h-3 w-14 bg-gray-100 rounded mb-2" />
                <div className="h-6 w-20 bg-gray-200 rounded mb-2" />
                <div className="h-3 w-16 bg-gray-100 rounded" />
            </div>
            <div className="flex-1 py-4 px-4">
                <div className="h-5 w-32 bg-gray-200 rounded mb-2" />
                <div className="h-4 w-20 bg-gray-100 rounded" />
            </div>
        </div>
    );
}

export function CookDashboardSkeleton() {
    return (
        <div className="min-h-screen bg-[#FAFAF9] pb-20 animate-pulse" data-testid="cook-dashboard-skeleton">
            {/* Header */}
            <div className="bg-white">
                <div className="px-4 py-3 flex items-start justify-between">
                    <div>
                        <div className="h-3 w-24 bg-gray-100 rounded mb-2" />
                        <div className="h-7 w-40 bg-gray-200 rounded" />
                    </div>
                    <div className="w-11 h-11 rounded-full bg-gray-100" />
                </div>
                {/* Sub-tabs */}
                <div className="flex border-t border-gray-100">
                    {[0, 1].map(i => (
                        <div key={i} className="flex-1 py-3 flex flex-col items-center gap-1.5">
                            <div className="h-4 w-24 bg-gray-200 rounded" />
                            <div className="h-3 w-16 bg-gray-100 rounded" />
                        </div>
                    ))}
                </div>
            </div>
            {/* Order cards */}
            <div className="p-4 flex flex-col gap-4">
                <div className="h-3 w-28 bg-gray-100 rounded" />
                {[0, 1, 2].map(i => <OrderCardSkeleton key={i} />)}
            </div>
        </div>
    );
}

export function CookOrderDetailSkeleton() {
    return (
        <div className="min-h-screen bg-[#F3F3F1] animate-pulse" data-testid="cook-order-detail-skeleton">
            <div className="bg-white border-b border-gray-100 px-4 py-4 flex items-center gap-3">
                <div className="w-5 h-5 bg-gray-100 rounded" />
                <div className="h-5 w-32 bg-gray-100 rounded" />
            </div>
            <div className="p-4 flex flex-col gap-4">
                <div className="rounded-2xl overflow-hidden shadow-sm">
                    <div className="bg-[#006f3c]/20 h-28" />
                    <div className="bg-[#eef3c9] h-20" />
                </div>
                <div className="bg-white rounded-2xl p-5 shadow-sm">
                    <div className="h-3 w-28 bg-gray-100 rounded mb-4" />
                    <div className="h-5 w-full bg-gray-100 rounded mb-3" />
                    <div className="h-5 w-3/4 bg-gray-100 rounded" />
                </div>
            </div>
        </div>
    );
}
